export default {
  hotelDeal: {
    promoTitle: '會員專屬飯店優惠',
    bookNow: '立即預訂',
    checkIn: '入住日期',
    checkOut: '退房日期',
    roomType: '房型',
    roomsCount: '房間數',
    adults: '成人',
    guestName: '賓客姓名',
    nationality: '國籍',
    confirmAndPay: '確認並付款',
    bookingConfirmed: '預訂已確認',
    viewDeal: '查看優惠 →',
    saveUpTo: '最高節省 {n}%',
    fromPerNight: '每晚低至 {price}'
  },
  common: {
    login:"Login",

  },
  header: {

  },
  footer: {

  },
  homepage: {

  },
  detail: {

  },
  search: {
   
  },

  
};
